module.exports = __webpack_public_path__ + "static/media/frutiger-55roman.a5d9a697.ttf";